import React, { useEffect } from "react";
import DataPembelianSupplier from "../../componen/supplierPenyedia/DataPembelianSupplier";
import DataUpahTukang from "../../componen/upahTukang/DataUpahTukang";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getMeAdmin } from "../../fitur/AuthSlice";
import { Layout } from "../../layout/Layout";


const DataUpahTukangPages = () => {
    const dispatch = useDispatch();
      const navigate = useNavigate();
      const { isError } = useSelector((state) => state.authAdmin);
    
      useEffect(() => { dispatch(getMeAdmin()); }, [dispatch]);
      useEffect(() => { if (isError) navigate("/"); }, [isError, navigate]);
  return (
    <Layout><DataUpahTukang /></Layout>
  )
}

export default DataUpahTukangPages